import { NavigationContainer } from "@react-navigation/native";
import react from "react";
import { Text, FlatList, StyleSheet, TouchableOpacity, Image } from "react-native";
import { View, Dimensions } from "react-native";


const Products = props => {
    const PrdtData = [
        {
            id: '1',
            title: 'اواپراتور هوایی',
            img: require('../assets/images/products/avaprator.jpg'),
        }
        ,
        {
            id: '2',
            title: 'کندانسور هوايی',
            img: require('../assets/images/products/کندانسور-افقی.jpg'),
        }
        ,
        {
            id: '3',
            title: 'کندانسور تبخیری',
            img: require('../assets/images/products/تبخیری.jpg'),
        }
        ,
        {
            id: '4',
            title: 'سیستم مرکزی فریونی - رک',
            img: require('../assets/images/products/سیستم-مرکزی-فریونی-رک-در-هاپیرمالرکتها.jpg'),
        }
        ,
        {
            id: '5',
            title: 'کندانسينگ يونيت',
            img: require('../assets/images/products/کندانسوریونیت.jpg'),
        }
        ,
        {
            id: '6',
            title: 'یونیت اسپلیت',
            img: require('../assets/images/products/کندانسوریونیت.jpg'),
        }
        ,
        {
            id: '7',
            title: 'چیلر تراکمی',
            img: require('../assets/images/products/کندانسوریونیت.jpg'),
        }
        , {
            id: '8',
            title: 'مبدل پوسته و لوله',
            img: require('../assets/images/products/کندانسورآبی.jpg'),
        }
        ,
        {
            id: '9',
            title: 'برج خنک کن',
            img: require('../assets/images/products/برج-خنک-کن-1.jpg'),
        }
        ,
        {
            id: '10',
            title: 'سیستم کنترل اتمسفر',
            img: require('../assets/images/products/سیستم-کنترل-اتمسفر-e1519223351794.jpg'),
        }
        ,
        {
            id: '11',
            title: 'سیستم سورتینگ',
            img: require('../assets/images/products/سیستم-سورتینگ.jpg'),
        }
        ,
        {
            id: '12',
            title: 'فین و کویل',
            img: require('../assets/images/products/فین-و-کویل-2-1-300x161.jpg'),
        }
        ,
        {
            id: '13',
            title: 'تابلو برق',
            img: require('../assets/images/products/تابلو-برق2.jpg'),
        }


    ]
    return (
        <View style={{ backgroundColor: '#e6e6e6', flex: 1, width: '100%', justifyContent: 'center' }}>
            <FlatList
                numColumns={2}

                data={PrdtData}
                style={{ margin: 7 }}
                renderItem={(itemList) =>
                    <View style={styles.listRow} >
                        <TouchableOpacity onPress={() => props.navigation.navigate('ProductsDetail', { product: itemList.item })}>
                            <Image source={itemList.item.img} style={styles.img} />
                            <Text style={styles.title}>{itemList.item.title}</Text>

                        </TouchableOpacity>
                    </View>
                }
            />
        </View>
    )
}
const styles = StyleSheet.create(
    {
        listRow: {
            display: 'block',
            height: 150,
            padding: 10,
            margin: 6,
            backgroundColor: '#fff',
            color: '#fff',
            borderRadius: 6,
            maxWidth: Dimensions.get('window').width / 2,
            flex: 0.5,
            shadowColor: '#000',
            shadowOffset: { width: 0, height: 0.5 },
            shadowOpacity: 0.7,
            shadowRadius: 2,
            justifyContent: 'center',
            width: '100%'

        }
        ,
        title: {

            paddingRight: 15,
            textAlignVertical: 'center',
            padding: 17,
            fontFamily: 'IranSans',
            fontSize: 14,
            textAlign: 'center'
        }
        ,
        img: {
            width: 76,
            height: 58,
            borderRadius: 3,
            resizeMode: 'contain',
            alignSelf: 'center',


        }
    }
)
export default Products;